
var Tasks = function(skipError){
    var status = {
        pending:0,
        stoped:1,
        running:2,
        finished:3
    }
    var _actions = {};
    var _prevResult;
    var _items = [];
    var _cItem = null;
    var _cIndex = -1;
    var _cStatus = status.pending;

    function _getNext(){
        if(_cStatus != status.stoped && _cStatus != status.finished){
            if(!_hasNext()){
                if(_cStatus == status.running) {
                    _cStatus = status.finished;
                    _action("finish");
                }
            } else {
                _cIndex++;
                _cItem = _items[_cIndex];
                return _cItem;
            }
        }
        return null;
    }

    function _hasNext(){
        return (_cIndex + 1 < _items.length);
    }
    function _reset(){
        _cItem = null;
        _cIndex = -1;
    }
    function _clear(){
        _reset()
    }
    function _status(status){
        _cStatus = status;
    }

    function _next(){
        var next = _getNext();
        if(next){
            _runItem(next)
        }
    }

    function _runItem(item){
        _action("next");
        _status(status.running)
        item.handler(item.data,_this);
    }

    function _run(){
        _action("start");
        _next();
    }
    function _on(name, handler){
        if(!_actions[name]){
            _actions[name] = [];
        }
        _actions[name].push(handler);
    }

    function _action(name){
        if(_actions[name]){
           for(var i =0; i < _actions[name].length; i++){
               _actions[name][i](_cItem);
           }
        }
    }
    function _goTo(key){
        var _i;
        for(var i = 0; i < _items.length;i++){
            if(_items[i].key === key) {
                  _cIndex = i;
                 _i = _cItem = _items[i];
                 break;
            }
        }
        if(_i){
           _runItem(_i);
        }
    }

    var _this = {
        add:function(handler, data, key){
            var _data = [].concat(data);
            for(var i = 0; i < _data.length; i++) {
                var _key = _items.length;
                if (key && isNaN(key)) {
                    _key = key;
                }
                _items.push({data: _data[i], handler: handler, status: 0, key: _key});
            }
            return _this;
        },
        next:function(){
            _next();
            return _this;
        },
        error: function(error){
            if(!skipError){
                _prevResult = error;
                this.stop();
                _action("error");
            }
            return _this;
        },
        stop: function(errorHandler){
           _status(status.stoped);
        },
        done: function(data){
            _prevResult = data;
            _action("done");
            this.next();
            return _this;
        },
        result: function(){
            return _prevResult;
        },
        reset:function(){
            _reset();
            return _this;
        },
        clear:function(){
            _clear();
            return _this;
        },
        run:function(){
            _run();
            return _this;
        },
        status:function(){
            return _cStatus;
        },
        on:function(name, handler){
            _on(name, handler);
            return _this;
        },
        go:function(key) {
             _goTo(key);
        }
    }
    return _this;
}